module.exports = __webpack_public_path__ + "fonts/PlusJakartaSans-Regular.ec6d5973.ttf";